export default function handleResponse(response) {
  const data = response.data;
  //console.log("Content-Type"+response.headers["content-type"]);
  if(response.status!==200){ return Promise.reject({httpCode:response.status, "result":false, "returnCode":1,               "returnText":"Server Error"});  }
  if(response.headers["content-type"]==="application/pdf"){return data;}
  if(data.returnCode!==0)  { return Promise.reject({httpCode:response.status, "result":false, "returnCode":data.returnCode, "returnText":data.returnText, "data":data}); }
  return data;
}
